import { useCustom } from "@refinedev/core";
import { useMarketplaceStore } from "../store/useMarketplaceStore";
import i18n from "../utils/i18n";

type GeneralSettings = {
  currencyDisplay: "LOCAL_CURRENCY" | "USD";
};

type CurrencyMode = "AUTO" | "FORCE_LOCAL" | "FORCE_USD";

export const useCurrency = (mode: CurrencyMode = "AUTO") => {
  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);

  const { data: settings, isLoading } = useCustom<GeneralSettings>({
    url: selectedCountry ? `store/${selectedCountry.id}/settings` : "",
    method: "get",
    queryOptions: {
      enabled: !!selectedCountry,
    },
  });

  const locale = i18n.language === "tr" ? "tr-TR" : "en-US";

  const currency = (() => {
    if (mode === "FORCE_USD") return "$";
    if (mode === "FORCE_LOCAL") return selectedCountry?.currency ?? "";

    return settings?.data?.currencyDisplay === "USD"
      ? "$"
      : (selectedCountry?.currency ?? "");
  })();

  const formatCurrency = (value: number, mode: CurrencyMode = "AUTO") => {
    const resolvedCurrency = (() => {
      if (mode === "FORCE_USD") return "$";
      if (mode === "FORCE_LOCAL") return selectedCountry?.currency ?? "";

      // AUTO
      return settings?.data?.currencyDisplay === "USD"
        ? "$"
        : (selectedCountry?.currency ?? "");
    })();

    if (!resolvedCurrency) return value.toString();

    return (
      new Intl.NumberFormat(locale, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value) +
      " " +
      resolvedCurrency
    );
  };

  return { currency, isLoading, formatCurrency };
};
